import VueRouter from 'vue-router';
import { store } from '../../../store';
import { getNamespaced } from '../../../store/utils/namespace';
import { NAVIGATION_NAMESPACE } from '../../../store/modules/navigation';
import { getTrackingService } from '@gig/magic-common';

export const RETURNING_USER_KEY = 'returning-user';

/**
 * Creates a guard that saves the last page the user
 * was on.
 */
export function initNavigationGuard(router: VueRouter) {
    router.afterEach((to) => {
        store.dispatch(
            getNamespaced(NAVIGATION_NAMESPACE, 'setPreviousUrl'),
            to.fullPath,
        );
        getTrackingService().trackPageView(to.fullPath);
    });
}
